import { configureStore } from "@reduxjs/toolkit";
import routeReducer from "./reducer"; // Import the correct reducer

const store = configureStore({
    reducer: {
        data: routeReducer // Ensure this key matches what useSelector expects
    }
});

export default store;
